// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Fw","play":"Gw"};